import { cva } from 'class-variance-authority';

export const connectionStatusBadgeVariants = cva(
  'inline-flex w-max min-w-0 max-w-full items-center rounded-md border font-medium',
  {
    variants: {
      // Keys mirror the DeviceConnectivityStatus vocabulary the BFF emits.
      status: {
        connected:
          'border-green-700 bg-green-50 text-green-700 dark:border-green-600 dark:bg-green-50 dark:text-green-900',
        disconnected:
          'border-red-700 bg-red-50 text-red-700 dark:border-red-600 dark:bg-red-50 dark:text-red-900',
        // Portal still claims connected but the last message is stale — a warning,
        // not yet a hard disconnect.
        likely_disconnected:
          'border-amber-700 bg-amber-50 text-amber-700 dark:border-amber-600 dark:bg-amber-50 dark:text-amber-900',
        // Neutral states: no usable signal / non-monitored / unspecified.
        no_status:
          'border-gray-400 bg-gray-50 text-gray-600 dark:border-gray-500 dark:bg-gray-50 dark:text-gray-800',
        unknown:
          'border-gray-400 bg-gray-50 text-gray-600 dark:border-gray-500 dark:bg-gray-50 dark:text-gray-800',
        unspecified:
          'border-gray-400 bg-gray-50 text-gray-600 dark:border-gray-500 dark:bg-gray-50 dark:text-gray-800',
        // The patient has no connectivity record at all. Neutral like the other
        // absences — it is not a degraded connection, it is the lack of a device.
        no_device:
          'border-gray-400 bg-gray-50 text-gray-600 dark:border-gray-500 dark:bg-gray-50 dark:text-gray-800',
      },
      size: {
        default: 'gap-0.5 px-2 py-1 text-xs',
        // Base tier stays compact for small screens (the common case);
        // scales up a little on larger viewports.
        sm: 'gap-1 px-1.5 py-0.5 text-[0.6875rem] leading-tight desktop:px-2 desktop:text-xs',
      },
    },
    defaultVariants: {
      status: 'connected',
      size: 'default',
    },
  },
);
